module.exports = __webpack_public_path__ + "static/media/grosgateau.953fd6f7.gif";